import React from "react";

class LoginErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, errorInfo) {
    // Keep the logging local to the login flow so the failure point is visible.
    console.error("Login flow render error", {
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "320px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            textAlign: "center",
            color: "#333",
          }}
        >
          <div style={{ maxWidth: "420px" }}>
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "12px",
              }}
            >
              Something went wrong while opening the OTP screen.
            </p>
            <p style={{ margin: 0, lineHeight: "1.5" }}>
              Please refresh the page and try again. If the issue persists,
              contact support.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default LoginErrorBoundary;
